import API from '../../apiConfig';

export const acceptTnc = async (data) => {
  const response = await API.post('user/tnc ', data);
  return response;
};

export const workingHours = async (data) => {
  const response = await API.post('supplier/profile', data);
  return response;
};
